// src/components/iaDashboard/header/DashboardHeader.jsx
import React, { useState } from "react";

export default function DashboardHeader({
  activeCount,
  pendingCount,
  finishedToday,
}) {
  const [period, setPeriod] = useState("7d");

  return (
    <header className="ia-dashboard-header">
      <div>
        <h1 className="ia-dashboard-title">IA do Amor – Dashboard 💗</h1>
        <p className="ia-dashboard-subtitle">
          Visão geral dos atendimentos, performance da IA e tempo de resposta.
        </p>
      </div>

      <div className="ia-dashboard-header-right">
        <div className="ia-dashboard-header-pills">
          <div className="ia-pill ia-pill-pendente">
            <span className="pill-dot" />
            Pendentes: <b>{pendingCount}</b>
          </div>
          <div className="ia-pill ia-pill-ativa">
            Ativas: <b>{activeCount}</b>
          </div>
          <div className="ia-pill ia-pill-finalizada">
            Finalizadas hoje: <b>{finishedToday}</b>
          </div>
        </div>

        <div className="ia-dashboard-filter">
          <span>Período:</span>
          <select
            value={period}
            onChange={(e) => setPeriod(e.target.value)}
          >
            <option value="1d">Hoje</option>
            <option value="7d">Últimos 7 dias</option>
            <option value="30d">Últimos 30 dias</option>
            <option value="90d">Últimos 90 dias</option>
          </select>
        </div>
      </div>
    </header>
  );
}
